import React from 'react';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  scrollTo?: string;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  scrollTo,
  children,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.(e);
  };
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-orange-600 text-white hover:bg-orange-700 focus:ring-orange-500 shadow-sm',
    secondary: 'bg-stone-800 text-white hover:bg-stone-900 focus:ring-stone-800 shadow-sm',
    outline: 'border-2 border-stone-200 text-stone-900 hover:bg-stone-50 focus:ring-stone-500'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  return <button className={`${`${`${cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} text-[16px]`} text-[16px]`} pl-[30px] pr-[30px]`} onClick={handleClick} {...props} data-id="element-181">
      {children}
    </button>;
}